import type { Json } from "../types";

// Query parameters that may carry personal data — never sent.
const DROP_PARAMS = /^(email|e-mail|mail|phone|tel|name|fio|password|pass|token|auth|code|otp|sms|login|user|card|address|_ym_uid|_ga)$/i;
const MAX_QUERY_LEN = 512;

/**
 * Raw (sanitised) query string of the page. Kept so that ad-network or
 * partner parameters we don't know about yet (new click ids, yclid variants,
 * partner tags) can be classified later from the data instead of waiting
 * for a pixel release.
 */
export function sanitisedQuery(search: string): string | null {
  if (!search || search.length < 2) return null;
  const params = new URLSearchParams(search);
  const kept: string[] = [];
  params.forEach((value, key) => {
    if (DROP_PARAMS.test(key)) return;
    if (value.indexOf("@") !== -1) return; // looks like an e-mail
    kept.push(encodeURIComponent(key) + "=" + encodeURIComponent(value.slice(0, 128)));
  });
  if (!kept.length) return null;
  return kept.join("&").slice(0, MAX_QUERY_LEN);
}

export function buildPageViewProps(isSpaNavigation = false): Record<string, Json> {
  const props: Record<string, Json> = { is_spa_navigation: isSpaNavigation };
  const q = sanitisedQuery(location.search);
  if (q) props.query = q;
  return props;
}
